import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
    groupsFormControl: {
        width: "250px"
    }
}));